$(function() {
	if (!$body.hasClass('page-template-page-blog') && !$body.hasClass('page-template-page-press') && !$body.hasClass('page-template-page-specials') && !$body.hasClass('page-template-page-shops') && !$body.hasClass('page-template-page-events'))
		return;

	var slider = $('.hero.featured_posts_slider');
	var postsContainer = $('section.posts');
	var loadMoreButton = $('#load_more_posts');
	var activeCategory = 'all';
	var page = 0;

	if (slider.length) {
		var isHome = $('body').hasClass('home');

		var slides = slider.find('.slide');

		$('.hero.featured_posts_slider').on('init', function(event){
			$('.hero.featured_posts_slider .slick-slide:not(.slick-active)').find('.content *').attr('tabindex', -1);

			$('.hero .slick-arrow').on('click', function() {
				setTimeout(function(){
					var currentSlideEl = $('.hero.featured_posts_slider .slick-active');
					currentSlideEl.find('.content *').first().focus();
				}, 100);
			});
		});

		initializeSlick(slider, {
			dots: false,
			infinite: true,
			speed: 700,
			slidesToShow: 1,
			fade: true,
			pauseOnFocus: true,
			pauseOnHover: false,
			autoplay: false,
			arrows: isHome ? false : true,
			nextArrow: '<button class="slider_arrow white next_arrow">Next</button>',
			prevArrow: '<button class="slider_arrow white prev_arrow">Previous</button>'
		}, function(e) {
			var hero = slider.parents('.hero');
			slider.addClass('ready');
			hero.addClass('ready');
		});

		slider.on('afterChange', function(e, slick) {
			slides.eq(0).removeClass('initial_load');
			slides.removeClass('current_slide').eq(slick.currentSlide).addClass('current_slide');

			if (isHome && slick.currentSlide == slides.length-1)
				slider.slick('slickPause');

			setTimeout(function(){
				currentSlideEl = $('.hero.featured_posts_slider .slick-active');
				$('.hero.featured_posts_slider .slick-slide').find('.content *').attr('tabindex', -1);
				currentSlideEl.find('.content *').attr('tabindex', 0);
			}, 100);
		});

		var interactedWithSlider = function(e) {
			slider.slick('slickPause');
		}
		slider.click(interactedWithSlider);
		slider.keyup(interactedWithSlider);

		$(window).on('panelsLoaded', function() {
			setTimeout(function() {
				slides.eq(0).addClass('initial_load');
				if (window.currentSlidersState != 2) {
					slider.slick('slickPlay');
				} else {
					slider.data('autoplay', 1);
				}
			}, isHome ? 1500 : 500);
		});
	}

	$('#filter_mobile_button').click(function(){
		$('#blog_categories nav').toggleClass('open');
	})

	function loadMorePosts(category, page, reset) {
		if (reset === true) {
			postsContainer.find('>*:not(#load_more_posts)').remove();
		}

		if (category)
			category += '/';

		var fetch_path = '/blog_api/' + category + page;
		if ($body.hasClass('page-template-page-press'))
			fetch_path = '/press_api/' + page;
		if ($body.hasClass('page-template-page-events'))
			fetch_path = '/events_api/' + category + page;

		$.get(fetch_path, function(response) {
			if (response.no_more) {
				loadMoreButton.hide();
			} else {
				loadMoreButton.show();
			}

			var newContainer = $('<div></div>');
			newContainer.append(response.html);
			if (loadMoreButton.length) {
				newContainer.insertBefore(loadMoreButton);
			} else {
				postsContainer.append(newContainer)
			}

			// filterCategory($('.active_category'));

			// newContainer.find('.post').each(function() {
			// 	lazyLoader.lazyLoad($(this), $(this).find('.image').attr('lazy-background'));
			// });
		});
	}

	loadMoreButton.click(function() {
		page += 1;
		loadMorePosts(activeCategory, page);
	});

	var filterCategory = function(element) {
		if (element)
			element = $(element);

		$('.active_category').removeClass('active_category');
		element.addClass('active_category');

		page = 0
		if (element.hasClass('category_reset')) {
			activeCategory = 'all';
			loadMorePosts(activeCategory, page, true);
		} else {
			activeCategory = element.attr('href').slice(1);
			loadMorePosts(activeCategory, page, true);
		}
	}

	$('#blog_categories a').click(function() {
		filterCategory(this);
	});

	// $('#blog_categories').accessibleScaffold({
	// 	items: 'a',
	// 	orientation: 'horizontal',
	// 	onEnterKey: function(item) {
	// 		filterCategory(item);
	// 	}
	// });


	var searchWrapper = $('#landing_search');
	var searchInput = searchWrapper.find('#search_input');
	searchWrapper.click(function() {
		searchWrapper.addClass('searching');
		searchInput.focus();
	});

	searchInput.keypress(function(e) {
		if (e.key == 'Enter') {
			var val = $(this).val();
			if (val)
				window.location = '/?s=' + val + '&t=' + ($(this).attr('data-type') || 'post');
			return false;
		}
	})
});